<template>
  <div>
    <van-action-sheet
      v-model="thatShow"
      get-container="body"
      title="拒绝接单原因"
      @close="close"
    >
      <div>
        <div :class="_['sheet-content']">
          <van-radio-group v-model="radio">
            <div
              v-for="(reas, index) in reason"
              :key="index"
              :class="_['check-item']"
              @click="radio = index"
            >
              <span :class="_['check-item-txt']">{{ reas }}</span>

              <van-radio :name="index" checked-color="#ee0a24"></van-radio>
            </div>
          </van-radio-group>
        </div>
        <div :class="[_['sheet-bottom'], _._hairlineTop]">
          <van-button
            round
            color="linear-gradient(to right, #ff6034, #ee0a24)"
            block
            @click="confirms()"
            >确定</van-button
          >
        </div>
      </div>
    </van-action-sheet>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default Vue.extend({
    props: {
      show: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        radio: 0,
        thatShow: false,
        reason: [
          '该菜品没货了，现在没办法做哦亲',
          '没有骑手接单，送不了呢',
          '因疫情管控，暂时无法配送',
          '其他原因',
        ],
      }
    },
    computed: {
      loading() {
        return false
      },
    },
    watch: {
      show(newValue) {
        this.thatShow = newValue
      },
    },
    methods: {
      close() {
        this.thatShow = false
        this.$emit('close')
      },
      confirms() {
        this.$emit('confirmReason', this.reason[this.radio])
      },
    },
  })
</script>

<style lang="scss" module>
  .sheet-content {
    padding: 20px 14px 40px 11px;
    font-size: 14px;
    .check-item {
      width: 100%;
      padding: 17px 0 17px 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .check-item-txt {
        width: 308px;
      }
    }
  }
  .sheet-bottom {
    width: (100%-24) px;
    height: 60px;
    display: flex;
    align-items: center;
    padding: 0 12px;
  }
</style>
